import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';
import utc from 'dayjs/plugin/utc';
dayjs.extend(isoWeek);
dayjs.extend(utc);

export const getLocalTimeBasedOnHoursAndMins = (utcHoursAndMins: string) => {
  const [hours, minutes, seconds] = utcHoursAndMins.split(':').map(Number);
  const now = new Date();
  const localTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), hours, minutes, seconds);
  return localTime;
};

export const getCurrentUtcDate = (): string => {
  return dayjs().utc().format('YYYY-MM-DD');
};

export const getNextFiveIsoWeeks = (): string[] => {
  let currentDay = dayjs().startOf('isoWeek');
  return [0, 1, 2, 3, 4].map((i) => {
    const weekDate = currentDay.add(i * 7, 'day');
    return `${weekDate.isoWeekYear()}-${weekDate.isoWeek().toString().padStart(2, '0')}`;
  });
};
